import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import { ProgramInfo } from '../containers/Programs';

const stylesObj = theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitleObj = withStyles(stylesObj)(props => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContentObj = withStyles(theme => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);
export default class ProgramPreviewButton extends Component {

    render() {
        const { program, onClose, getPlanNotes, clientEmail } = this.props;
   
        return (
            <div>
                <Dialog onClose={() => onClose() } aria-labelledby="customized-dialog-title" open={true}>
                    <DialogTitleObj id="customized-dialog-title" onClose={() => onClose()}>
                        View Notes
                </DialogTitleObj>
                    <DialogContentObj dividers>
                        <Typography gutterBottom component="span">
                            <div className="modalBody modal-content" style={{ width: 320 }}>
                                <ProgramInfo 
                                    isViewProgramNotes={true} 
                                    getProgramWorkoutNotes={getPlanNotes}
                                    clientEmail = {clientEmail}  
                                    programId={program._id} 
                                />
                            </div>
                        </Typography>
                    </DialogContentObj>
                </Dialog>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ProgramNotes.js